import { gql } from "@apollo/client";
import "typesafe-actions";
import "normalizr";
import "rxjs";
import "rxjs/operators";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "react-redux";
import "react-router";
import { EntitySubscription } from "../../redux-folder/realtime/services/EntitySubscription.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
class UserProfileSubscription extends EntitySubscription {
  getResponseMappers() {
    return {
      Add: (s) => s.userProfileAdded ? [s.userProfileAdded] : [],
      Update: (s) => s.userProfileUpdatedV2 ? [s.userProfileUpdatedV2] : [],
      Delete: void 0
    };
  }
  getEntityFragment() {
    return gql`
            fragment UserProfileFragment on UserProfile {
                uid
            }
        `;
  }
  getSubscriptions() {
    const fragment = this.getEntityFragment();
    return {
      Add: gql`
                ${fragment}

                subscription OnUserProfileAdded {
                    userProfileAdded {
                        ...UserProfileFragment
                    }
                }
            `,
      Update: gql`
                ${fragment}

                subscription OnUserProfileUpdated($filter: SubscriptionListFilter) {
                    userProfileUpdatedV2(filter: $filter) {
                        ...UserProfileFragment
                    }
                }
            `,
      Delete: void 0
    };
  }
}
export {
  UserProfileSubscription
};
//# sourceMappingURL=subscription.js.map
